import Storage from "./storage.service";
import HTTP from "./http.service";
import SHA256 from "crypto-js/sha256";
import Settings from "./settings.service";
import Numbers from "./numbers.service";
import Helpers from "../helpers/shared.helper";
import Summaries from "./summaries.service";
import CONSTANTS from "./constants.service";
import Errors from "./errors.service";
import Flow from "./flow.service";
import Products from "./products.service";

var Payments = {};

Payments.signature_command = "TOKENIZATION";
Payments.token_command = "TOKENIZATION";

Payments.signature_fields = [
	"return_url",
	"access_code",
	"language",
	"merchant_extra",
	"merchant_identifier",
	"merchant_reference",
];

Payments.payfort_fields = [
	"access_code",
	"card_holder_name",
	"card_number",
	"card_security_code",
	"expiry_date",
	"language",
	"merchant_identifier",
	"merchant_extra",
	"merchant_reference",
	"return_url",
	"signature",
	"service_command",
];

Payments.getPaymenOperation = (operation) => {
	switch (operation) {
		case "purchaseWithAuth":
			return 11;
		case "auth":
			return 13;
		case "purchase":
			return 14;
		default:
			return 11;
	}
};

Payments.setFlags = (
	skip_cc = true,
	request_delivery = true,
	redirect = false
) => {
	let flags = Storage.get("flags");
	Storage.set("chose_delivery", request_delivery, true);
	flags.IsCreditCardSkipped = skip_cc;
	flags.chose_payment_option = true;
	Storage.set("flags", flags);
	if (redirect) {
		Flow.next(2);
	}
};


Payments.createApplePaymentRequestKW = () => {
	// VM-KSA-Onboarding-Apple-Pay // Step 3
	let totals = Storage.get("paymentPrice", true);
	Helpers.debug_payment("totals", totals);
	return {
		countryCode: Settings.apple_pay_country_code,
		currencyCode: Settings.apple_pay_currency,
		supportedNetworks: Settings.apple_pay_supported_networks,
		merchantCapabilities: ["supports3DS"],
		total: { label: "Total", amount: totals },
		version: Settings.apple_pay_version_number,
	};
};

Payments.sendPaymentTokenKw = (paymentToken, booking_code) => {
	return new Promise(function (resolve, reject) {
		let data = Payments.getAppleParameters(paymentToken);
		data["booking_code"] = booking_code;
		Payments.registerAndPayAppleKw(data)
			.then((res) => {
				resolve(res);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

Payments.validateAppleUrlNewKw = () => {
	// VM-KSA-Onboarding-Apple-Pay
	let config = {
		method: "post",
		url: "apple/request_payment_session_new",
	};
	return HTTP(config);
};

Payments.appleBeginKw = () => {
	// VM-KSA-Onboarding-Apple-Pay // Step 2
	let request = Payments.createApplePaymentRequestKW(); // PKPaymentRequest

	let session = new window.ApplePaySession(
		Settings.apple_pay_version_number,
		request
	);



	Numbers.fetchNumber("1")
		.then((res) => {
			let number = res.data["numbers"][0];
			Storage.set('numselected', number?.MSISDN, true);
			Storage.set('vanityselected', number?.VanityLevelId, true);
			if (number && number["BookingCode"]) {
				let booking_code = number["BookingCode"];

				session.begin();

				Helpers.debug_payment("session.begin()");

				session.oncancel = (event) => {
					Helpers.debug_payment("session.oncancel event", event);
					Storage.clear("selected_payment_method");
					Storage.set("paymentSuccess", false, true);
					window.location.href = "/join/#/apple-pay-failure";
				};

				session.onpaymentauthorized = (event) => {

					Helpers.debug_payment("session.onpaymentauthorized event", event);
					// VM-KSA-Onboarding-Apple-Pay // Step 4
					Payments.sendPaymentTokenKw(event.payment.token, booking_code)
						.then((res) => {

							Helpers.debug_payment("sendPaymentToken res", res);

							let status = window.ApplePaySession.STATUS_SUCCESS;
							session.completePayment(status);
							Storage.set("apple_pay_success", true);
							Storage.set("paymentSuccess", true, true)
							window.location.href = '/join/#/confirmation-apple';
						})
						.catch((error) => {
							session.abort();
							Storage.set("paymentSuccess", false, true);
							window.location.href = "/join/#/apple-pay-failure";
						});
				};

				session.onvalidatemerchant = (event) => {

					Helpers.debug_payment("session.onvalidatemerchant event", event);
					if (event.validationURL) {
						Payments.validateAppleUrlNewKw()
							.then((merchantSession) => {
								Helpers.debug_payment("merchantSession", merchantSession);
								session.completeMerchantValidation(merchantSession.data);
							})
							.catch((error) => {
								Helpers.debug_payment("ERROR_MERCHANT_VALIDATION");
								session.abort();
								Errors.handleError(CONSTANTS.ERROR_MERCHANT_VALIDATION);
							});
					} else {
						Helpers.debug_payment("ERROR_MERCHANT_VALIDATION");
						Errors.handleError(CONSTANTS.ERROR_MERCHANT_VALIDATION);
					}
				};

			} else {

				Helpers.debug_payment("ERROR_NO_NUMBER");
				Storage.clear("selected_payment_method");
				session.abort();
				Errors.handleError(CONSTANTS.ERROR_NO_NUMBER);
			}
		});


};

Payments.getApplyPayConfigureStatus = () => {
	if (!Products.isFeatureAllowed(CONSTANTS.APPLE_PAY_FEATURE)) {
		return Helpers.emptyReject();
	}
	if (window.ApplePaySession && Helpers.isHTTPS()) {
		return Promise.resolve(window.ApplePaySession.canMakePayments());
	}
	return Helpers.emptyReject();
};

Payments.normalize = () => {
	Storage.clear("paymentFailedError");
	Storage.clear("paymentErrorStatus");
	Storage.clear("calledFeatureConfirmation");
	Storage.clear("confirmSuccess");
	Storage.clear("confirmFailed");
	Storage.clear("paymentSuccess");
}

Payments.payWithApple = () => {
	Payments.normalize();
	Storage.set("selected_payment_method", CONSTANTS.PAYMENT_METHOD_APPLE);
	Payments.appleBegin();
};

Payments.payWithCard = () => {
	Payments.normalize();
	Storage.set("selected_payment_method", CONSTANTS.PAYMENT_METHOD_CARD);
};

Payments.payWithAppleKw = () => {
	// VM-KSA-Onboarding-Apple-Pay // Step 1
	Payments.normalize();
	Storage.set("selected_payment_method", CONSTANTS.PAYMENT_METHOD_APPLE);
	Payments.appleBeginKw();
};

Payments.payWithTapCard = () => {
	Payments.normalize();
	Storage.set("selected_payment_method", CONSTANTS.PAYMENT_TAP_CARD, true);
}

Payments.validateAppleUrl = (data) => {
	let config = {
		method: "post",
		data: data,
		url: "apple/request_payment_session",
	};
	return HTTP(config);
};

Payments.validateAppleUrlNew = () => {
	let config = {
		method: "post",
		url: "apple/request_payment_session_new",
	};
	return HTTP(config);
};

Payments.getAppleParameters = (paymentToken) => {
	let data = {};
	data["apple_network"] = paymentToken.paymentMethod.network || "";
	data["apple_displayName"] = paymentToken.paymentMethod.displayName || "";
	data["apple_type"] = paymentToken.paymentMethod.type;
	data["apple_data"] = paymentToken.paymentData.data;
	data["apple_signature"] = paymentToken.paymentData.signature;
	data["apple_transactionId"] = paymentToken.paymentData.header.transactionId;
	data["apple_ephemeralPublicKey"] = paymentToken.paymentData.header.ephemeralPublicKey;
	data["apple_publicKeyHash"] = paymentToken.paymentData.header.publicKeyHash;
	data["apple_application_data"] = "";
	data["payment_operation"] = Payments.getPaymenOperation();
	return data;
};

Payments.sendPaymentToken = (paymentToken, booking_code) => {
	return new Promise(function (resolve, reject) {
		let data = Payments.getAppleParameters(paymentToken);
		data["booking_code"] = booking_code;
		Payments.registerAndPayApple(data)
			.then((res) => {
				resolve(res);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

Payments.appleBegin = () => {

	let request = Payments.createApplePaymentRequest(); // PKPaymentRequest

	let session = new window.ApplePaySession(
		Settings.apple_pay_version_number,
		request
	);

	Numbers.fetchNumber("1")
		.then((res) => {
			let number = res.data["numbers"][0];
			if (number && number["BookingCode"]) {
				let booking_code = number["BookingCode"];

				session.begin();

				Helpers.debug_payment("session.begin()");

				session.oncancel = (event) => {
					Helpers.debug_payment("session.oncancel event", event);
					Storage.clear("selected_payment_method");
					window.location.reload();
				};

				session.onpaymentauthorized = (event) => {

					Helpers.debug_payment("session.onpaymentauthorized event", event);

					Payments.sendPaymentToken(event.payment.token, booking_code)
						.then((res) => {

							Helpers.debug_payment("sendPaymentToken res", res);

							let status = window.ApplePaySession.STATUS_FAILURE;
							if (res) {
								status = window.ApplePaySession.STATUS_SUCCESS;
							}

							session.completePayment(status);

							if (res) {
								Storage.set("apple_pay_success", true);
							} else {
								Errors.handleError(CONSTANTS.ERROR_APPLE_PAY);
							}
						})
						.catch((error) => {
							Errors.handleError(CONSTANTS.ERROR_PAYMENT_AUTHORIZATION);
							session.abort();
						});
				};

				session.onvalidatemerchant = (event) => {

					Helpers.debug_payment("session.onvalidatemerchant event", event);

					if (event.validationURL) {

						// let data = {
						// 	merchantI_identifier: Settings.apple_merchant_id,
						// 	display_name: Settings.apple_merchant_displayname,
						// 	initiative: Settings.apple_merchant_initiative,
						// 	initiative_context: Settings.apple_merchant_initiative_context,
						// };

						Payments.validateAppleUrlNew()
							// Payments.validateAppleUrl(data)
							.then((merchantSession) => {

								Helpers.debug_payment("merchantSession", merchantSession);

								session.completeMerchantValidation(merchantSession.data);
							})
							.catch((error) => {
								Helpers.debug_payment("ERROR_MERCHANT_VALIDATION");
								session.abort();
								Errors.handleError(CONSTANTS.ERROR_MERCHANT_VALIDATION);
							});
					} else {
						Helpers.debug_payment("ERROR_MERCHANT_VALIDATION");
						Errors.handleError(CONSTANTS.ERROR_MERCHANT_VALIDATION);
					}
				};

			} else {
				Helpers.debug_payment("ERROR_NO_NUMBER");
				Storage.clear("selected_payment_method");
				session.abort();
				Errors.handleError(CONSTANTS.ERROR_NO_NUMBER);
			}
		});


};

Payments.createApplePaymentRequest = () => {
	let totals = Summaries.calculateTotalPrice();

	Helpers.debug_payment("totals", totals);

	return {
		countryCode: Settings.apple_pay_country_code,
		currencyCode: Settings.apple_pay_currency,
		supportedNetworks: Settings.apple_pay_supported_networks,
		merchantCapabilities: ["supports3DS"],
		total: { label: "Total", amount: totals.total_with_vat },
		// applicationData: "",
		version: Settings.apple_pay_version_number,
	};
};

Payments.registerAndPayApple = (data) => {
	const paymentCaptureEnabled = Helpers.getStorageBooleanValue(CONSTANTS.ENABLE_PAYMENT_CAPTURE);
	let config = {
		method: "post",
		url: paymentCaptureEnabled ? "credit_cards/register_and_pay_apple" : "/apple/register_and_pay_apple",
		data: data,
	};
	return HTTP(config);
};

Payments.registerAndPayAppleKw = (data) => {
	// VM-KSA-Onboarding-Apple-Pay
	const paymentCaptureEnabled = Helpers.getStorageBooleanValue(CONSTANTS.ENABLE_PAYMENT_CAPTURE);
	let config = {
		method: "post",
		url: paymentCaptureEnabled ? "credit_cards/register_and_pay_apple" : "/apple/register_and_pay_apple",
		data: data,
	};
	return HTTP(config);
};

Payments.createSignature = (state) => {
	Helpers.debug_payment("Payments.createSignature()");
	let params = {};
	let text = "";
	// 1. Sort all PayFort requests parameters (both mandatory and optional) in an ascending alphabetical order based on the parameters names.
	let payment_constants = Storage.get("payment_constants");

	let data = Object.assign(payment_constants, state);
	let fields = Object.keys(data).sort();
	for (let v = 0; v < fields.length; v++) {
		params[fields[v]] = data[fields[v]];

		if (Payments.signature_fields.indexOf(fields[v]) !== -1) {
			// 2. Concatenate the parameter name with the value separated by ’=’ (param_name=param_value).
			let pair = fields[v] + "=" + params[fields[v]];
			// 3. Concatenate all the parameters directly without any separator. (param_name1=param_value1param_name2=param_value2).
			text += pair;
		}
	}

	text += "service_command=" + Payments.signature_command;

	// 4. Add the Merchant’s Passphrase at the beginning and end of the parameters string. (REQUESTPHRASEparam_name1=param_value1param_name2=param_value2RE QUESTPHRASE).
	let with_passphrase =
		payment_constants.merchant_passphrase +
		text +
		payment_constants.merchant_passphrase;

	// 5. Use the SHA function to generate the SHA value of the resulted string depending on the type of SHA selected by the Merchant.
	let with_sha = SHA256(with_passphrase);
	with_sha = with_sha.toString().toUpperCase();

	Storage.set("signature", with_sha);

	Helpers.log("signature = " + with_sha);
};

Payments.initiateIframe = (dis, state, form_id, iframe_id) => {
	Helpers.debug_payment("Payments.initiateIframe()");
	let iframe_wrapper = document.getElementById(iframe_id);

	let command = {
		service_command: Payments.token_command,
		signature: Storage.get("signature"),
	};

	let data1 = Object.assign(Storage.get("payment_constants"), command);
	let data = Object.assign(data1, state);

	let data_keys = Object.keys(data).sort();

	if (document.getElementById(form_id)) {
		document.getElementById(form_id).remove();
	}

	var form = document.createElement("form");
	form.setAttribute("action", Settings.payfort_get_token_endpoint);
	form.setAttribute("method", "POST");
	form.setAttribute("id", form_id);
	// form.setAttribute("action", "http://localhost:3000/payfort_token");
	form.setAttribute("style", "display:none");
	form.setAttribute("target", "payfort");

	for (let v = 0; v < data_keys.length; v++) {
		if (Payments.payfort_fields.indexOf(data_keys[v]) !== -1) {
			let prop = data_keys[v];
			var el = document.createElement("input");
			el.setAttribute("name", prop);
			el.setAttribute("value", data[prop]);
			form.appendChild(el);
		}
	}

	iframe_wrapper.appendChild(form);

	let interval = setInterval(function () {
		if (document.getElementById(form_id)) {
			form.submit();
			Helpers.debug_payment("submitted get token form");
			clearInterval(interval);
		}
	}, 500);

	window.setToken = function (tok) {
		if (tok) {
			Helpers.debug_payment("window.setToken", tok);
			window.payfort_token = tok;
			Storage.set("cvv", dis.state.card_security_code);
			Storage.set("card_holder_name", dis.state.card_holder_name);
			Storage.set("save_card", dis.state.save_card);
			Storage.set("payfort_token", tok);
		} else {
			Helpers.debug_payment("window.setToken error", tok);
			Payments.actionOnPaymentFail();
			Storage.set("payment_error", true);
			Errors.handleError(CONSTANTS.ERROR_PAYMENT_AUTHORIZATION);
		}

	};
};

Payments.confirm3d = (data) => {
	Helpers.debug_payment("Payments.confirm3d(data)", data);
	let config = {
		method: "post",
		url: "/numbers/commit_number_and_confirm_3d_secure",
		data: data,
	};
	return HTTP(config);
};

Payments.confirmNon3d = (data) => {
	Helpers.debug_payment("Payments.confirmNon3d(data)", data);
	let config = {
		method: "post",
		url: "/numbers/commit_number",
		data: data,
	};
	return HTTP(config);
};

Payments.saveCard = (data) => {
	Helpers.debug_payment("Payments.saveCard(data)", data);
	let config = {
		method: "post",
		url: "/payments/plans_with_alias",
		data: data,
	};
	return HTTP(config);
};

Payments.topupSaveCard = (data) => {
	Helpers.debug_payment("Payments.saveCard(data)", data);
	let config = {
		method: "post",
		url: "/quick_topup/online_oneoff",
		data: data,
	};
	return HTTP(config);
};

Payments.CommonSaveCard = (data, apiEndpoint) => {
	Helpers.debug_payment("Payments.saveCard(data)", data);
	let config = {
		method: apiEndpoint?.method,
		url: apiEndpoint?.endpoint,
		data: data,
	};
	return HTTP(config);
};


Payments.verifyPayfortResponse = (data) => {
	Helpers.debug_payment("Payments.verifyPayfortResponse(data)", data);
	const paymentCaptureEnabled = Helpers.getStorageBooleanValue(CONSTANTS.ENABLE_PAYMENT_CAPTURE);
	let config = {
	 method: "post",
	 url: paymentCaptureEnabled ? "/credit_cards/confirm_registration" : "/credit_cards/confirm_3d_secure",
	 data: data,
	};
	return HTTP(config);
};

Payments.actionOnPaymentFail = () => {
	Storage.clear("order_id");
	Storage.clear("save_card");
	Storage.clear("payfort_token");
};

Payments.actionOnPaymentSuccess = () => {
	Storage.clear("order_id");
	Storage.clear("save_card");
	Storage.clear("payfort_token");
};

//use services for Kuwait
	Payments.payOnboardingKw = (data) => {
		Helpers.debug_payment("Payments.payOnboardingKw(data)", data);
		const paymentCaptureEnabled = Helpers.getStorageBooleanValue(CONSTANTS.ENABLE_PAYMENT_CAPTURE);
		let config = {
			method: "post",
			url: paymentCaptureEnabled ? "/credit_cards/pay_onboarding" : "payments/pay_onboarding",
			data: data,
		};
		return HTTP(config);
	}
	Payments.checkEligabilityKW = (data) => {
		Helpers.debug_payment("Payments.checkEligabilityKW(data)", data);
		let config = {
			method: "post",
			url: "/credit_cards/check_eligability",
			data: data,
		};
		return HTTP(config);
	}
	Payments.confirmOnlinePaymentKw = (data) => {
		let config = {
			method: "post",
			url: "/payments/confirm",
			data: data
		}
		return HTTP(config)
	}

	Payments.creditCardsKnetPayment = () => {
		let config = {
			method: "post",
			url: "/credit_cards/knet_onboarding",
		}
		return HTTP(config)
	}
	Payments.paymentKnetOnboardingKw = () => {
		Payments.creditCardsKnetPayment()
			.then(response => {
				// window.location.href="https://sandbox.payments.tap.company/test_gosell/v2/payment/tap_process.aspx?chg=8D9e9fdEo5NjXFaEYWMUX1VEEXEv%2flsWGykQ2l%2fcp0o%3d";
				if (response && response.data && response.data.Status && response.data.HTML_ANSWER) {
					let order_id = {};
					let status = {};
					order_id[Storage.get("session")] = response.data.OrderID;
					status[Storage.get("session")] = response.data.Status;
					Helpers.debug_payment('order_id', order_id);

					Storage.set("order_id", JSON.stringify(order_id), true);
					Storage.set("status", JSON.stringify(status), true);
					window.location.href = response.data.HTML_ANSWER;
				} else {

					// window.location.href="http://localhost:3000/join#/confirmation?session=15"	
					Storage.set("payment_error", true);
					throw new Error("Failed to load Knet payment");
				}
			})
			.catch(error => {
				Errors.handleError();
			})
	}

	Payments.topupVerifyPayfortResponse = (data) => {
		Helpers.debug_payment("Payments.topupVerifyPayfortResponse(data)", data);
		let config = {
			method: "post",
			url: "/quick_topup/online_oneoff_confirmation",
			data: data,
		};
		return HTTP(config);
	};

	Payments.verifyPayfortResponse = (data) => {
		Helpers.debug_payment("Payments.verifyPayfortResponse(data)", data);
		const paymentCaptureEnabled = Helpers.getStorageBooleanValue(CONSTANTS.ENABLE_PAYMENT_CAPTURE);
		let config = {
			method: "post",
			url: paymentCaptureEnabled ? "/credit_cards/confirm_registration" : "/credit_cards/confirm_3d_secure",
			data: data,
		};
		return HTTP(config);
	};

	Payments.actionClearPaymentStorage = () => {
		Storage.clear("order_id");
		Storage.clear("save_card");
		Storage.clear("tap_data");
		Storage.clear("status");
		Storage.set("storage_cleared", true);
	};

	Payments.cancelOnboarding = (data) => {
		let config = {
			method: "post",
			// With Payment Capturing
			url: "/credit_cards/cancel_onboarding",
			data: data,
		};
		return HTTP(config);
	};

	Payments.checkPaymentAuthorizationStatus = () => {
		let config = {
			method: "get",
			url: "/payments/check_authorization_status",
		};
		return HTTP(config);
	};

	Payments.retryConfirmRegistration = () => {
		Helpers.debug_payment("Payments.retryConfirmRegistration()");
		let config = {
			method: "post",
			url: "/credit_cards/retry_confirm_registration",
		};
		return HTTP(config);
	};

	Payments.proceedWithoutPayment = (data) => {
		let config = {
			method: "post",
			url: "/payments/confirm_zero_payment",
			data: data,
		};
		return HTTP(config);
	};

	
export default Payments;
